import { Pet, PetRole } from 'shared/@generated/models';

type PetWithRole = { role?: PetRole | null };

export function isForSalePet(pet: PetWithRole) {
  return !pet.role || pet.role === PetRole.Offspring;
}

export function isParentPet(pet: PetWithRole) {
  return pet.role === PetRole.Mother || pet.role === PetRole.Father;
}

export function getForSalePets<T extends PetWithRole>(pets: T[]) {
  return pets.filter(isForSalePet);
}

export function getParentPets<T extends PetWithRole>(pets: T[]) {
  return pets.filter(isParentPet);
}

export function getParentPet<T extends Pick<Pet, 'role'>>(pets: T[], role: PetRole) {
  return pets.find((pet) => pet.role === role) ?? null;
}
